import React, { useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Input,
  Pagination,
  Table,
  Toggle,
  Tooltip,
  Whisper,
} from "rsuite";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { ProductivityReportVM } from "../../Models/ViewModels";
import { GetProductivityReport } from "../../Services/KRAApprovalDB";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../SharedComponents/PageHeader";
import Moment from "moment";
const { Column, HeaderCell, Cell } = Table;
export const TeamProductionReport = () => {
  const [cachedResult, setCachedResult] = useState(
    new Array<ProductivityReportVM>()
  );
  const [filteredResult, setFilteredResult] = useState(
    new Array<ProductivityReportVM>()
  );
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [toggled, setToggled] = useState(false);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [sortType, setSortType] = useState();
  const [sortColumn, setSortColumn] = useState();
  const [searching, setSearching] = useState(false);
  const [currentdate, setcurrentdate] = React.useState<Date>();
  useEffect(() => {
    GetProductivityreportList(loginid);
  }, [toggled]);

  const GetProductivityreportList = (loginid: any) => {
    if (!toggled) {
      GetProductivityReport(loginid, "MTD").then((res) => {
        setcurrentdate(new Date(res.data[0].SubmittedOn));
        setCachedResult(res.data);
        setFilteredResult(res.data);
        setLoading(false);
      });
    } else {
      GetProductivityReport(loginid, "Daywise").then((res) => {
        setcurrentdate(new Date(res.data[0].SubmittedOn));
        setCachedResult(res.data);
        setFilteredResult(res.data);
        setLoading(false);
      });
    }
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredResult.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const tableDataFeed = filteredResult.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;

    setPage(1);
    if (searchText) {
      setFilteredResult(
        cachedResult.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setFilteredResult([...cachedResult]);
    }
  };

  const handleDate = (date: Date) => {
    if (!toggled) {
      // const month = date.getUTCMonth() + 1;
      // var mmyyyy = date.getFullYear() + "/" + month;

      const dateFormatted = Moment(date).format("YYYY/M");
      setcurrentdate(new Date(dateFormatted));
      setFilteredResult(
        cachedResult.filter((e) =>
          JSON.stringify(e.SubmittedOn).includes(dateFormatted.toString())
        )
      );
    } else {
      // const month = date.getUTCMonth() + 1;
      // const d = date.getUTCDate();
      // var mm = "" + month;
      // var dd = "" + d;
      // if (month < 10) mm = "0" + month;
      // if (d < 10) dd = "0" + d;
      // var ddmmyy = date.getFullYear() + "-" + mm + "-" + dd;
      const dateFormatdayWise = Moment(date).format("YYYY-MM-DD");
      setcurrentdate(new Date(dateFormatdayWise));
      setFilteredResult(
        cachedResult.filter((e) =>
          JSON.stringify(e.SubmittedOn).includes(dateFormatdayWise.toString())
        )
      );
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-sm-7">
          <PageHeader title="Team Productivity Report" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-sm-5">
          <div className="row">
            <div className="col-sm-2">
              <Toggle
                size="lg"
                checkedChildren="DayWise"
                unCheckedChildren="MTD"
                onChange={(toggled: boolean, event) => setToggled(toggled)}
              />
            </div>

            <div className="col-md-5">
              <Input
                className="form-control w-100 border border-dark"
                placeholder="Search..."
                type={"search"}
                id="search"
                onChange={handleFilterData}
              />{" "}
            </div>
            {!toggled ? (
              <div className="col-sm-3">
                <DatePicker
                  oneTap
                  format="yyyy/MM"
                  value={currentdate}
                  onSelect={(date: Date) => handleDate(date)}
                  onClean={(event) => GetProductivityreportList(loginid)}
                />
              </div>
            ) : (
              <div className="col-sm-3">
                <DatePicker
                  oneTap
                  format="yyyy-MM-dd"
                  value={currentdate}
                  onSelect={(date: Date) => handleDate(date)}
                  onClean={(event) => GetProductivityreportList(loginid)}
                />
              </div>
            )}
            <div className="col-sm-1">
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(filteredResult)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>

      <div className="show-container " bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          loading={isLoading}
          onSortColumn={handleSortColumn}
          height={450}
          bordered={true}
          sortColumn={sortColumn}
          sortType={sortType}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column flexGrow={170} align="center" fixed>
            <CustomTableHeaderCell placement={"EmpID"}>
              EmpID
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeOfficeBadgeId" />
          </Column>

          <Column flexGrow={220} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Name"}>
              Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="FullName" />
          </Column>

          <Column flexGrow={200} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Designation"}>
              Designation
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeDesignation" />
          </Column>

          <Column flexGrow={200} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Lead"}>
              Lead
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="PrimaryReportingOfficer" />
          </Column>
          <Column flexGrow={200} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Total Production"}>
              Total Production
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="TotalProduction" />
          </Column>

          {!toggled ? (
            <Column flexGrow={200} align="center" fixed sortable>
              <CustomTableHeaderCell placement={"Sum Of Production %"}>
                Sum Of Production %
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="TotalProductionPercent" />
            </Column>
          ) : (
            <></>
          )}
          {!toggled ? (
            <Column flexGrow={200} align="center" fixed sortable>
              <CustomTableHeaderCell placement={"MTD Production %"}>
                MTD Production %
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="MTDProductionPercent" />
            </Column>
          ) : (
            <Column flexGrow={125} align="center" fixed sortable>
              <CustomTableHeaderCell placement={"Day's Production %"}>
                Day's Production %
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="TotalProductionPercent" />
            </Column>
          )}
          {!toggled ? (
            <Column flexGrow={116} align="center" fixed sortable>
              <CustomTableHeaderCell placement={"Working Days"}>
                Working Days
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="WorkingDays" />
            </Column>
          ) : (
            <></>
          )}
          {!toggled ? (
            <Column flexGrow={170} align="center" fixed sortable>
              <CustomTableHeaderCell placement={"YYYY/MM(Year/Month)"}>
                YYYY/MM
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="SubmittedOn" />
            </Column>
          ) : (
            <Column flexGrow={170} align="center" fixed>
              <CustomTableHeaderCell placement={"Date"}>
                Date
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: any) => {
                  return rowData.SubmittedOn.substring(
                    0,
                    rowData.SubmittedOn.indexOf("T")
                  );
                }}
              </CustomTableCell>
            </Column>
          )}
        </Table>

        {filteredResult && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredResult.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
